module.exports = __webpack_public_path__ + "static/media/eg.0f048f11.jpg";